import { WheelchairIcon } from './WheelchairIcon';

/**
 * author: Michael Irigoyen
 * id 1984D53A-267C-4E05-956A-ABED5B2029BE
 * name wheelchair
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wheelchair.svg
 * tags
 * - Medical / Hospital 
 * - People / Family 
 */
export const IsaIcon = WheelchairIcon;
export default IsaIcon